app-featured-media {
    article {
        @include padding-direction(top, 64);
        @include padding-direction(bottom, 64);

        .container {

            .content-wrapper {
                display: flex;
                justify-content: center;
                align-items: center;

                .cta-media {
                    position: relative;
                    height: 420px;

                    .video-embed-btn {
                        max-width: 531px;
                    }

                    .img {
                        height: 420px;
                        max-width: 531px;
                    }

                    .img img {
                        max-width: 100%;
                        margin: 0 auto;
                    }

                    .video-embed {

                        button {
                            padding-right: 0;
                            padding-left: 0;
                        }
                    }
                }

                .cta-content {
                    min-height: 420px;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: center;

                    .cta-content-inner {
                        max-width: 590px;

                        .heading {
                            color: $gray-dark;
                            @include text-size(32);
                            @include line-height(40);
                            @include margin-direction(bottom, 24);
                        }

                        .description {
                            @include text-size(16);
                            @include line-height(24);
                            color: $gray-dark;
                            text-align: left;
                            @include margin-direction(bottom, 32);

                            ul,
                            ol {
                                max-width: 100%;
                                @include padding-direction(bottom, 20);
                                margin-bottom: 0;

                                li {
                                    color: $gray-dark;
                                    @include text-size(16);
                                    @include line-height(24);
                                    @include paddings(0, 0, 10, 0);
                                }

                            }

                            * {
                                color: $gray-dark;
                                @include text-size(16);
                                @include line-height(24);
                            }

                            p {
                                /* Override default p styles (WYSIWYG editor adds <p> for normal content) */
                                padding: inherit;
                                color: inherit;
                                margin: inherit;
                                line-height: inherit;
                                font-size: inherit;
                                font-weight: inherit;
                            }

                            a {
                                color: $tertiary;
                                text-decoration: underline;

                                &:hover,
                                &:focus {
                                    text-decoration: none;
                                }
                            }

                            &.checkmark {
                                ul, ol {
                                    list-style-type: none;

                                    li {
                                        position: relative;

                                        &::before {
                                            position: absolute;
                                            content: url("/themes/custom/qsci/frontend/www/assets/icon/check-solid.svg");
                                            margin-top: 0.1875rem;
                                            margin-right: 0rem;
                                            margin-bottom: 0rem;
                                            margin-left: -1.125rem;
                                            width: 14px
                                        }
                                    }
                                }
                            }
                        }


                        .ctas {
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;

                            .btn.btn-primary {
                                @include margin-direction(right, 24);
                            }

                            .arrow-link__underline {
                                color: $gray-dark;
                            }
                        }
                    }
                }
            }
        }

        &.app-featured-media__right {
            .container {

                .content-wrapper {
                    flex-direction: row-reverse;

                    .cta-media {

                        .img {
                            margin-left: auto;
                        }
                    }
                }
            }
        }

        @include media-breakpoint-down(xl) {
            @include padding-direction(top, 48);
            @include padding-direction(bottom, 48);

            .container {

                .content-wrapper {
                    flex-direction: column;

                    .cta-media {
                        height: auto;
                        width: 100%;

                        .video-embed-btn {
                            max-width: none;
                        }

                        .img {
                            background-repeat: no-repeat;
                            background-size: contain !important;
                            background-position: 50% 50%;
                            max-width: 100%;
                        }
                    }

                    .cta-content {
                        min-height: auto;
                        width: 100%;
                        align-items: center;

                        .cta-content-inner {
                            @include margin-direction(top, 24);

                            .heading {
                                @include text-size(24);
                                @include line-height(29);
                                @include margin-direction(bottom, 24);
                                text-align: center
                            }

                            .description {
                                text-align: center;
                                @include text-size(16);
                                @include line-height(24);
                                @include margin-direction(bottom, 32);

                                ul,
                                ol {
                                    
                                    li {
                                        text-align: left !important;
                                    }

                                }

                                * {
                                    color: $gray-dark;
                                    @include text-size(16);
                                    @include line-height(24);
                                }
                            }


                            .ctas {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;

                                .btn.btn-primary {
                                    margin-right: 0;
                                    @include margin-direction(bottom, 25);
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
            }

            &.app-featured-media__right {

                .container {

                    .content-wrapper {
                        flex-direction: column;
                    }
                }
            }
        }

        @include media-breakpoint-down(sm) {
            .container {

                .content-wrapper {

                    .cta-media {

                        .img {
                            max-height: 223px !important;
                        }
                    }
                }
            }
        }
    }
}